import {ReportCompare, ReportPeriod} from "../../../generated/graphql";

// Modul „Auswertungen“: Texte bewusst nur Deutsch (wie „KI-Assistent“), i18n folgt mit der Ausweitung auf englische Mandanten.

export const periodLabels: Record<ReportPeriod, string> = {
    [ReportPeriod.Week]: "Diese Woche",
    [ReportPeriod.Month]: "Dieser Monat",
    [ReportPeriod.Quarter]: "Dieses Quartal",
    [ReportPeriod.Year]: "Dieses Jahr",
};

export const compareLabels: Record<ReportCompare, string> = {
    [ReportCompare.Previous]: "Vorperiode",
    [ReportCompare.LastYear]: "Vorjahr",
};

export const weekdayLabels = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
export const monthLabels = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

const sourceNames: Record<string, string> = {
    direct: "Direkt",
    staff: "Büro",
    google: "Google",
    "chatgpt.com": "ChatGPT",
    chatgpt: "ChatGPT",
    newsletter: "Newsletter",
    instagram: "Instagram",
    facebook: "Facebook",
    bing: "Bing",
};

export const sourceLabel = (source: string): string => sourceNames[source] ?? source.charAt(0).toUpperCase() + source.slice(1);

export const formatInt = (value: number): string => new Intl.NumberFormat("de-DE", {maximumFractionDigits: 0}).format(value);

/** Tag YYYY-MM-DD als TT.MM. */
export const shortDay = (day: string): string => `${day.slice(8, 10)}.${day.slice(5, 7)}.`;
